<template>
  <PForm
    title="Ajouter un lien"
    :submit-fn="submit"
    @close="
      resetForm();
      emit('update:modelValue', false);
    "
    :updating="modelValue"
  >
    <template #activator="{}">
      <span class="hidden"></span>
    </template>

    <div>
      <PInput label="Nom" v-model="name" :error-messages="nameErrors" data-sentry-id="DocLinkFormNameInput" />
      <PInput
        label="Lien"
        v-model="url"
        :error-messages="urlErrors"
        help="Privilégiez les liens https"
        placeholder="https://"
        data-sentry-id="DocLinkFormLinkInput"
      />
    </div>
  </PForm>
</template>

<script setup lang="ts">
import { FormOperation } from "@/app/types";
import { PForm, PInput, usePastaValidation } from "@pasta/box-v2";
import { required, url as isUrl } from "@vuelidate/validators";
import { inject } from "vue";
import { useNotifyAsyncOperation } from "../../../composable/useAsyncOperation";
import { LetterFileDocumentType } from "../../../dto/letter-file-document.dto";
import { useLetterFileDocumentApi } from "../../../http/letter-file-document.api";
import { type FormProvide, FormToken } from "../utils";

interface Props {
  modelValue: boolean;
  rootFolderId: number;
}
const props = defineProps<Props>();

const emit = defineEmits<{ (e: "update:modelValue", value: boolean): void }>();

const documentApi = useLetterFileDocumentApi();
const notifyAsyncOperation = useNotifyAsyncOperation();
const { refresh, letterFile } = inject<FormProvide>(FormToken)!;

const validation = usePastaValidation({ $stopPropagation: true });
const [name, nameErrors] = validation.ref<string>("", [{ validator: required, message: "Ce champ est requis" }]);
const [url, urlErrors] = validation.ref<string>("", [
  { validator: required, message: "Ce champ est requis" },
  { validator: isUrl, message: "Ce champ doit être une url valide" },
]);

async function submit() {
  const isValid = await validation.validate();
  if (!isValid) return false;

  await notifyAsyncOperation(async () => {
    await documentApi.create(
      {
        folder: props.rootFolderId,
        type: LetterFileDocumentType.URL,
        name: name.value,
        url: url.value,
      },
      letterFile.value!.id
    );
    await refresh();
  }, FormOperation.DOCUMENT);

  resetForm();
  return true;
}

function resetForm() {
  validation.reset();
  name.value = "";
  url.value = "";
}
</script>
